// Shared Last Month / Last Quarter definitions (plans 2195, 2201). LOCAL date math on purpose: never
// toISOString().split('T')[0], which shifts the day for viewers west of UTC.
const pad = (n) => String(n).padStart(2, '0');
const fmt = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;
const lastDayOf = (year, month) => new Date(year, month, 0).getDate();

export function lastMonthRange(now = new Date()) {
  const y = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
  const m = now.getMonth() === 0 ? 12 : now.getMonth();
  return { startDate: fmt(y, m, 1), endDate: fmt(y, m, lastDayOf(y, m)) };
}

export function lastQuarterRange(now = new Date()) {
  const q = Math.floor(now.getMonth() / 3);
  const y = q === 0 ? now.getFullYear() - 1 : now.getFullYear();
  const lastQ = q === 0 ? 3 : q - 1;
  const endMonth = lastQ * 3 + 3;
  return { startDate: fmt(y, lastQ * 3 + 1, 1), endDate: fmt(y, endMonth, lastDayOf(y, endMonth)) };
}

export const localDateString = (d = new Date()) => fmt(d.getFullYear(), d.getMonth() + 1, d.getDate());

// One-click presets for pages that only have free date inputs or a hand-rolled period menu.
export const lastPeriodPresets = (now = new Date()) => [
  { label: 'Last Month', ...lastMonthRange(now) },
  { label: 'Last Quarter', ...lastQuarterRange(now) },
];
